import {
  EMPTY,
  MONTHS_ABBREVIATIONS,
  START_YEAR,
} from "../configurations/Constants";

const DashboardHelper = {
  getYearAcresForIrrigUnitID(year, irrig_unit_id, acresYearData) {
    const acres = EMPTY;
    if (!acresYearData.hasOwnProperty(irrig_unit_id)) return acres;
    const yearData = acresYearData[irrig_unit_id].tp_year_wise_data.filter(
      (yearRow) => yearRow.crop_year.toString() === year.toString()
    );
    return yearData[0].acres === null ? acres : yearData[0].acres;
  },

  getNumberOfDays(endDate, startDate) {
    let difference = endDate.getTime() - startDate.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays + 1;
  },

  getAcresYearData(meterData) {
    let acresYearData = {};
    if (meterData.data.acres && Object.keys(meterData.data.acres).length > 0) {
      acresYearData = meterData.data.acres;
    }
    return acresYearData;
  },

  generateCropsAndTillagesArray(entities) {
    const { crops = [], tillages = [] } = entities;
    const CropArray = crops.map((value) => {
      const item = { id: value.crop_name, text: value.crop_name };
      return item;
    });
    const TillageArray = tillages.map((value) => {
      const item = { value: value.tillage_name, label: value.tillage_name };
      return item;
    });
    return { CropArray, TillageArray };
  },

  getValidatedSeasons(shareFieldData) {
    let seasonAllowed = [];
    if (!shareFieldData.length) return seasonAllowed;
    for (let j = 0; j < shareFieldData.length; j++) {
      let currentyear = new Date().getFullYear();
      let rowData = shareFieldData[j];
      if (rowData.rejected) continue;
      let addedDate = new Date(rowData.added_on);
      let addedYear = addedDate.getFullYear();
      let removedOn = rowData.removed;
      let removedYear = removedOn ? new Date(removedOn).getFullYear() : null;

      if (addedYear === removedYear && removedYear !== null) {
        seasonAllowed.push({
          year: addedYear,
          permission: false,
          fieldId: rowData.user_field_id,
        });
      }
      for (let year = addedYear; year <= (removedYear || currentyear); year++) {
        const seasonChangeDate = new Date(`15/APR/${year}`).getTime();
        let permission = false;
        if (year === removedYear && removedOn < seasonChangeDate) continue;
        if (removedYear == null && rowData.editor) permission = true;
        seasonAllowed.push({
          year,
          permission,
          fieldId: rowData.user_field_id,
        });
      }
    }
    return seasonAllowed;
  },

  calcGraphDays(
    month,
    selectedYear,
    startDateState,
    endDateState,
    startDate,
    endDate
  ) {
    //to calculate start and end date for bar graph data
    // 1 Day = 86400000 miliseconds
    let barGraphEndDate = new Date();
    let filterMonth = month;

    // when only year is selcted
    let GraphDayCount = 31;
    let previousDay = new Date(barGraphEndDate - 86400000);
    let date = previousDay.getDate();
    let cmonth = Number(new Date(previousDay).getMonth()) + 1;
    barGraphEndDate = new Date(cmonth + "/" + date + "/" + selectedYear);
    if (isNaN(barGraphEndDate.getTime())) {
      barGraphEndDate = new Date();
    }
    if (filterMonth && filterMonth.length > 0) {
      //if month is selected
      let latestMonth = filterMonth[filterMonth.length - 1];
      GraphDayCount = new Date(
        selectedYear,
        parseInt(latestMonth.value),
        0
      ).getDate();
      barGraphEndDate = new Date(
        latestMonth.value + "/" + GraphDayCount + "/" + selectedYear
      );
      if (isNaN(barGraphEndDate.getTime())) {
        barGraphEndDate = new Date();
      }
    } else if (startDateState && endDateState) {
      barGraphEndDate = endDate;
      if (startDate.getMonth() === endDate.getMonth()) {
        //same month
        if (endDate.getDate())
          GraphDayCount = endDate.getDate() - startDate.getDate() + 1;
        if (GraphDayCount < 15) GraphDayCount = 15;
      } else if (
        endDate.getMonth() - startDate.getMonth() > 0 &&
        endDate.getFullYear() - startDate.getFullYear() === 0
      ) {
        //more than 1 month
        GraphDayCount = this.getNumberOfDays(
          new Date(
            `${
              endDate.getMonth() + 1
            }/${endDate.getDate()}/${endDate.getFullYear()}`
          ),
          new Date(
            `${
              startDate.getMonth() + 1
            }/${startDate.getDate()}/${startDate.getFullYear()}`
          )
        );
        if (GraphDayCount < 15) GraphDayCount = 15;
        else if (GraphDayCount > 62) GraphDayCount = 62;
      } else if (endDate.getFullYear() - startDate.getFullYear() === 1) {
        //date range across 2 years
        let startYearLastDate = new Date(
          12 + "/" + 31 + "/" + startDate.getFullYear()
        );
        barGraphEndDate = startYearLastDate;
        GraphDayCount = this.getNumberOfDays(
          new Date(
            `${
              startYearLastDate.getMonth() + 1
            }/${startYearLastDate.getDate()}/${startYearLastDate.getFullYear()}`
          ),
          new Date(
            `${
              startDate.getMonth() + 1
            }/${startDate.getDate()}/${startDate.getFullYear()}`
          )
        );
        if (GraphDayCount < 15) GraphDayCount = 15;
        else if (GraphDayCount > 62) GraphDayCount = 62;
      }
    }
    let barGraphStartDate = new Date(
      barGraphEndDate - 86400000 * (GraphDayCount - 1)
    );
    return { GraphDayCount, barGraphEndDate, barGraphStartDate };
  },

  getSeasonalYear() {
    let currentSeasonYear = new Date().getFullYear();
    const dateForNewSeason = new Date(`01/APR/${currentSeasonYear}`).getTime();
    const dataToday = new Date().getTime();
    return dataToday < dateForNewSeason
      ? currentSeasonYear - 1
      : currentSeasonYear;
  },

  getRangeParams(rangeArr = []) {
    let rangeParam = EMPTY;
    let startDate = rangeArr[0];
    let endDate = rangeArr[1];
    if (!rangeArr.length) return rangeParam;
    // date range includes 2 years
    if (endDate.getFullYear() - startDate.getFullYear() === 1) {
      let startYearLastDate = new Date(`12/31/${startDate.getFullYear()}`);
      const q1 = startDate.getMonth() + 1;
      const q2 = startDate.getDate();
      const q3 = startYearLastDate.getMonth() + 1;
      const q4 = startYearLastDate.getDate();
      rangeParam = `start_date=${q1}-${q2}&end_date=${q3}-${q4}`;
      return rangeParam;
    }
    const q1 = startDate.getMonth() + 1;
    const q2 = startDate.getDate();
    const q3 = endDate.getMonth() + 1;
    const q4 = endDate.getDate();
    rangeParam = `start_date=${q1}-${q2}&end_date=${q3}-${q4}`;
    return rangeParam;
  },

  getWaterDataQueryUrl(currentYear, monthArr = [], rangeArr) {
    let queryUrl = currentYear ? `/waterdata/${currentYear}` : "/waterdata";
    const monthParam = monthArr.length ? `months=[${monthArr}]` : EMPTY;
    const rangeParam = this.getRangeParams(rangeArr);
    if (monthParam) queryUrl = `${queryUrl}?${monthParam}`;
    else if (rangeParam) queryUrl = `${queryUrl}?${rangeParam}`;
    return queryUrl;
  },

  getInchesPerAcre(tableData = [], electricData = [], acresYearData) {
    const formattedArr = tableData.map((item) => {
      let total = 0;
      let avg = 0;
      const finder = (e) =>
        e.field_id === item.field_id &&
        e.farm_practice_id === item.farm_practice_id;
      const inchPerAcre = electricData.find(finder);
      if (inchPerAcre) {
        const item = parseFloat(inchPerAcre.inches).toFixed(2);
        total = Number(total) + Number(item);
        avg = total.toFixed(2);
      } else {
        avg = total.toFixed(2);
      }
      const acres = this.getYearAcresForIrrigUnitID(
        item.year,
        item.irrig_unit_id,
        acresYearData
      );
      if (acres !== EMPTY && item.crop_id === null) item.acres_utilized = acres;
      if (acres !== EMPTY && parseFloat(acres) !== 0) item.total_acres = acres;
      item.inches_acres = avg;
      return item;
    });
    return formattedArr;
  },

  getCropData(
    cropUpdated,
    userFieldData,
    seasonAllowed,
    cropDataValue,
    currentYear
  ) {
    if (cropUpdated) return cropDataValue;
    let cropData = [];
    const dataWithCrop = userFieldData.data.fields;
    dataWithCrop.forEach((value) => {
      //------------------------   filters     ------------------------------------------------------------------------------------//
      const currentYrCropsFilter = (crop) =>
        crop.field_id === value.field_id && +crop.year === +currentYear;
      const seasonFinder = (field) =>
        +field.year === +currentYear && field.fieldId === value.field_id;
      const noCropIDFilter = (crop) =>
        crop.field_id === value.field_id &&
        +crop.year === +currentYear &&
        !crop.crop_id;
      const seasonNotCurrent = (field) =>
        +field.year === +value.year &&
        field.fieldId === value.field_id &&
        +value.year !== +currentYear;
      //------------------------------------------------------------------------------------------------------------------------//
      if (value.is_shared_field) {
        const seasonsCount = seasonAllowed.filter(seasonFinder).length;
        const notCurrentSeasons = seasonAllowed.filter(seasonNotCurrent).length;
        if (!seasonsCount || (!value.year && !seasonsCount)) return;
        if (value.year && +currentYear !== +value.year && !notCurrentSeasons) {
          const o_data = dataWithCrop.filter(currentYrCropsFilter);
          const added_data = cropData.filter(noCropIDFilter);
          const noCropsForFieldFilter = (field) => {
            return (
              +field.year === +currentYear &&
              field.fieldId === value.field_id &&
              !o_data.length &&
              !added_data.length
            );
          };
          if (
            !value.year ||
            !seasonAllowed.filter(noCropsForFieldFilter).length
          )
            return;
          cropData.push({
            field_name: value.field_name,
            acres_utilized: value.acres_utilized,
            inches_acres: EMPTY,
            crop: EMPTY,
            tillage: EMPTY,
            business_name: value.business_name,
            farm_name: value.farm_name,
            field_id: value.field_id,
            irrig_unit_id: value.irrig_unit_id,
            crop_id: null,
            farm_practice_id: value.farm_practice_id,
            year: currentYear,
            total_acres: value.total_acres,
            is_shared_field: value.is_shared_field,
          });
          return;
        }
      }
      let field_id = value.field_id;
      let o_data = dataWithCrop.filter(
        (crop) => crop.field_id === field_id && crop.crop_id && crop.year
      );
      let c_data = dataWithCrop.filter(
        (crop) =>
          crop.field_id === field_id &&
          crop.crop_id &&
          crop.year &&
          +crop.year === +currentYear
      );
      if (
        ((o_data.length > 0 && c_data.length === 0) ||
          (o_data.length === 0 && c_data.length === 0)) &&
        !cropData.some((crop) => crop.field_id === field_id)
      ) {
        cropData.push({
          field_name: value.field_name,
          acres_utilized:
            value.acres_utilized === EMPTY
              ? value.total_acres
              : value.acres_utilized,
          inches_acres: EMPTY,
          crop: EMPTY,
          tillage: EMPTY,
          business_name: value.business_name,
          farm_name: value.farm_name,
          field_id: field_id,
          irrig_unit_id: value.irrig_unit_id,
          crop_id: null,
          farm_practice_id: value.farm_practice_id,
          year: currentYear,
          total_acres: value.total_acres,
          is_shared_field: value.is_shared_field,
        });
      }
    });
    const nonSharedFields = (crop) =>
      crop.year === currentYear && crop.crop_id && !crop.is_shared_field;
    cropData = cropData.concat(
      userFieldData.data.fields.filter(nonSharedFields)
    );
    cropData = cropData.concat(
      userFieldData.data.fields.filter(
        (crop) =>
          crop.year === currentYear &&
          crop.crop_id &&
          crop.is_shared_field &&
          seasonAllowed.filter(
            (field) =>
              +field.year === +currentYear &&
              field.fieldId === crop.field_id &&
              +crop.year === +currentYear
          ).length
      )
    );
    return cropData;
  },

  setBusinessArray(businessData, cropKey, cropValue) {
    if (
      businessData.some(
        (objValue) => objValue.label === cropValue.business_name
      )
    )
      return businessData;
    businessData.push({ value: cropKey, label: cropValue.business_name });
    return businessData;
  },

  setFarmArray(business, farmData, cropKey, cropValue) {
    if (farmData.some((objValue) => objValue.label === cropValue.farm_name))
      return farmData;
    const farmBusiness = business.map((b) => b.label);
    if (
      !farmBusiness.length ||
      farmBusiness.includes(cropValue.business_name)
    ) {
      farmData.push({ value: cropKey, label: cropValue.farm_name });
    }
    return farmData;
  },

  setCropTypeArray(cropTypeArray, crops) {
    for (let i = 0; i < crops.length; i++) {
      if (cropTypeArray.length === crops.length) return cropTypeArray;
      let cropobj = {
        value: crops[i].id,
        label: crops[i].text,
      };
      cropTypeArray.push(cropobj);
    }
    return cropTypeArray;
  },

  setYearDataArray(yearData) {
    let runningYear = new Date().getFullYear();
    for (let i = runningYear; i >= START_YEAR; i--) {
      if (!yearData.some((objValue) => objValue.label === i)) {
        let yearobj = {
          value: i,
          label: i,
        };
        yearData.push(yearobj);
      }
    }
    return yearData;
  },

  FilterByYearMonth(meterData, electricDetail, yearValue, month) {
    if (!meterData || !meterData.length) return electricDetail;
    meterData.forEach((dayRecord) => {
      if (!yearValue) return;
      const { field_id, inches, farm_practice_id } = dayRecord;
      electricDetail.push({ field_id, inches, farm_practice_id });
    });

    return electricDetail;
  },

  FilterByDateRange(meterData, electricDetail, seasonAllowed, year) {
    if (!meterData && !meterData.length) return electricDetail;
    meterData.forEach((dayRecord) => {
      let hasAccess = true;
      const { field_id, inches, farm_practice_id } = dayRecord;
      const sharedFieldDetails = seasonAllowed.filter(
        (season) => season.fieldId === dayRecord.field_id
      );

      if (sharedFieldDetails.length) {
        const hasYear = sharedFieldDetails.filter((d) => +d.year === +year);
        hasAccess = hasYear.length > 0;
      }
      if (hasAccess)
        electricDetail.push({ field_id, inches, farm_practice_id });
    });
    return electricDetail;
  },

  getBarChartDetails(
    barGraphElectricData,
    sharedField,
    selectedField,
    showBarChart,
    GraphDayCount,
    barGraphEndDate
  ) {
    let optionValue = [];
    let seriesValue = [];
    if (!barGraphElectricData) return { optionValue, seriesValue };
    if (Object.keys(barGraphElectricData).length === 0) {
      for (let i = 1; i <= GraphDayCount; i++) {
        optionValue.push(
          barGraphEndDate.getDate() +
            " " +
            MONTHS_ABBREVIATIONS[barGraphEndDate.getMonth()]
        );
        seriesValue.push(0);
        barGraphEndDate = new Date(barGraphEndDate - 86400000);
      }
    } else {
      for (const key in barGraphElectricData) {
        let splitDate = key.split("-");
        let date = new Date(splitDate[0], splitDate[1] - 1, splitDate[2]);
        optionValue.push(
          date.getDate() + " " + MONTHS_ABBREVIATIONS[date.getMonth()]
        );

        if (sharedField === true) {
          if (showBarChart === true) {
            let value = barGraphElectricData[key];
            seriesValue.push(Number(value));
          } else {
            seriesValue.push(0);
          }
        } else {
          if (selectedField) {
            let value = barGraphElectricData[key];
            seriesValue.push(Number(value));
          } else {
            seriesValue.push(0);
          }
        }
      }
    }
    return { optionValue, seriesValue };
  },

  getLineChartDetails(lineGraphValues, eData) {
    let cumulativeArray = lineGraphValues.cumulativeArray;
    let fieldArray = lineGraphValues.fieldArray;

    if (!eData) return;
    let inchValuePerMonth = 0;
    let cumulativeValue = 0;

    for (let i = 0; i <= 11; i++) {
      inchValuePerMonth = 0;
      inchValuePerMonth = Number(eData[i]);
      fieldArray[i] = inchValuePerMonth.toFixed(2);
      cumulativeValue = Number(cumulativeValue) + Number(inchValuePerMonth);
      cumulativeArray[i] = cumulativeValue.toFixed(2);
    }
    return { cumulativeArray, fieldArray };
  },

  UpdateFieldAndCropDataArray(
    response,
    cropDataValue,
    userFieldDataValue,
    fieldRow,
    selectedYear,
    selectedCrop,
    selectedTillage
  ) {
    let fieldId = parseFloat(fieldRow.field_id);
    let editedCrop = response.data.data.filter((crop) => {
      return (
        crop.user_field_id === fieldId &&
        crop.crop === selectedCrop &&
        crop.year === selectedYear
      );
    });
    if (editedCrop.length !== 1) return { userFieldDataValue, cropDataValue };

    let editFieldOld = userFieldDataValue.data.fields.filter((field) => {
      return field.field_id === fieldId;
    });
    let existingCrop = userFieldDataValue.data.fields.filter((field) => {
      return field.field_id === fieldId && field.year === selectedYear;
    });

    if (existingCrop.length === 0) {
      let newCrop = {
        field_name: editFieldOld[0].field_name,
        acres_utilized: editFieldOld[0].acres_utilized,
        inches_acres: EMPTY,
        crop: selectedCrop,
        tillage: selectedTillage,
        business_name: editFieldOld[0].business_name,
        farm_name: editFieldOld[0].farm_name,
        field_id: fieldId,
        irrig_unit_id: editFieldOld[0].irrig_unit_id,
        crop_id: editedCrop[0].id,
        year: selectedYear,
        total_acres: editFieldOld[0].total_acres,
        is_shared_field: editFieldOld[0].is_shared_field,
      };
      userFieldDataValue.data.fields.forEach((field, index) => {
        if (field.field_id === fieldId) {
          userFieldDataValue.data.fields[index] = newCrop;
        }
      });
    } else {
      let cropToUpdate = existingCrop[0];
      if (cropToUpdate.crop_id === null) {
        cropToUpdate.crop_id = editedCrop[0].id;
        cropToUpdate.crop = selectedCrop;
        cropToUpdate.tillage = selectedTillage;
        cropToUpdate.year = selectedYear;
        cropToUpdate.acres_utilized = fieldRow.total_acres;
      } else if (cropToUpdate.crop_id !== null) {
        cropToUpdate.crop = selectedCrop;
        cropToUpdate.tillage = selectedTillage;
      }
    }
    let cropData = cropDataValue.filter((crop) => {
      return crop.field_id === fieldId && crop.year === selectedYear;
    });
    if (cropData.length > 0) {
      let cropDataToUpdate = cropData[0];
      if (cropDataToUpdate.crop_id === null) {
        cropDataToUpdate.crop_id = editedCrop[0].id;
        cropDataToUpdate.crop = selectedCrop;
        cropDataToUpdate.tillage = selectedTillage;
      } else if (cropDataToUpdate.crop_id !== null) {
        cropDataToUpdate.crop = selectedCrop;
        cropDataToUpdate.tillage = selectedTillage;
      }
    }
    return { userFieldDataValue, cropDataValue };
  },

  sortAlphaNumeric(a, b, sorting) {
    let reA = /[^a-zA-Z]/g;
    let reN = /[^0-9]/g;
    if (sorting === "fieldName") {
      let aA = a.field_name.toLowerCase().replace(reA, EMPTY);
      let bA = b.field_name.toLowerCase().replace(reA, EMPTY);
      if (aA === bA) {
        let aN = parseInt(a.field_name.replace(reN, EMPTY), 10);
        let bN = parseInt(b.field_name.replace(reN, EMPTY), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    } else if (sorting === "acres") {
      let aA = a.acres_utilized.replace(reA, EMPTY);
      let bA = b.acres_utilized.replace(reA, EMPTY);
      if (aA === bA) {
        let aN = parseInt(a.acres_utilized.replace(reN, EMPTY), 10);
        let bN = parseInt(b.acres_utilized.replace(reN, EMPTY), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    } else if (sorting === "inchesacre") {
      let aA = a.inches_acres.toString().replace(reA, EMPTY);
      let bA = b.inches_acres.toString().replace(reA, EMPTY);
      if (aA === bA) {
        let aN = parseInt(a.inches_acres.toString().replace(reN, EMPTY), 10);
        let bN = parseInt(b.inches_acres.toString().replace(reN, EMPTY), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    } else if (sorting === "crop") {
      let aA = a.crop.replace(reA, EMPTY);
      let bA = b.crop.replace(reA, EMPTY);
      if (aA === bA) {
        let aN = parseInt(a.crop.replace(reN, EMPTY), 10);
        let bN = parseInt(b.crop.replace(reN, EMPTY), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    } else if (sorting === "tillage") {
      let aA = a.tillage.replace(reA, EMPTY);
      let bA = b.tillage.replace(reA, EMPTY);
      if (aA === bA) {
        let aN = parseInt(a.tillage.replace(reN, EMPTY), 10);
        let bN = parseInt(b.tillage.replace(reN, EMPTY), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    }
  },
  stripHtml(htmlValue) {
    let temp = document.createElement("DIV");
    temp.innerHTML = htmlValue;
    return temp.textContent || temp.innerText || EMPTY;
  },
};

export default DashboardHelper;
